import AppConfigurationSettings from '../../components/AppConfigurationSettings';

export function DemoAppConfigurationPage() {
  return (
    <div className="min-h-screen p-6">
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-2">Demo App Configuration</h2>
        <p className="text-sm text-gray-600">
          Manage Demo application sidebar items and UI configurations.
        </p>
      </div>

      <div className="bg-white shadow rounded-lg">
        <div className="p-6">
          <AppConfigurationSettings applicationFilter="demo" defaultApplication="demo" />
        </div>
      </div>
    </div>
  );
}

export default DemoAppConfigurationPage;
